import { Controller } from 'stimulus'
import { connectToParent } from '@app/javascript/classes/iframe'

export default class extends Controller {
  static values = {
    recordId: Number
  }

  initialize() {
    this.connection = connectToParent()
  }

  viewIssue(event) {
    const recordId = this.recordIdValue || event.detail[0].data.issue_id

    if (this.connection) {
      this.connection.promise.then((parent) => {
        parent.viewIssue(recordId)
      })
    }
  }

  editIssue() {
    if (this.connection) {
      this.connection.promise.then((parent) => {
        parent.editIssue(this.recordIdValue)
      })
    }
  }

  editLegacyReport() {
    if (this.connection) {
      this.connection.promise.then((parent) => {
        parent.editLegacyReport(this.recordIdValue)
      })
    }
  }
}
